export default __webpack_public_path__ + "static/media/descending-bars.f7861299.svg";